module.exports = __webpack_public_path__ + "static/media/nat-9.b525a99b.jpg";